<template>
  <li role="treeitem" :class="[baseCss, items.disabled ? ['disabled', 'pointer-events-none'] : null]">
    <container @click.native="toggle(items)" :title="items.node.name" :class="['whitespace-nowrap', 'cursor-pointer']">
      <icon
        v-if="isFolder"
        :provider="iconProvider"
        :color="iconColor"
        :color-lightness="iconColorLightness"
        :name="isOpen ? folderOpen : folderClosed"
        :class="['m-1']" />
      <icon
        v-else-if="!isFolder && showFileIcon"
        :provider="iconProvider"
        :color="iconColor"
        :color-lightness="iconColorLightness"
        :name="fileIcon"
        :class="['m-1']" /><!--
        --><checkbox
      :icon-color="iconColor"
      :icon-provider="iconProvider"
      :icon-color-lightness="iconColorLightness"
      v-if="checkboxes"
      v-model="items.selected" /><!--
        --><span :class="['inline-block', 'align-middle', !isFolder && !showFileIcon ? 'bcq-treeview-item-label-no-file-icon' : 'bcq-treeview-item-label']" v-html="items.node.name" />
    </container>
    <transition name="slide">
      <ul v-if="isFolder && isOpen">
        <treeview-item
          @node-click="$emit('node-click', $event)"
          v-for="(child, index) in items.children"
          :file-icon="fileIcon"
          :class="['outline-none']"
          :show-file-icon="showFileIcon"
          :folder-open="folderOpen"
          :folder-closed="folderClosed"
          :icon-color="iconColor"
          :checkboxes="checkboxes"
          :icon-provider="iconProvider"
          :icon-color-lightness="iconColorLightness"
          :key="index"
          :items="child" />
      </ul>
    </transition>
  </li>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'TreeviewItem',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      isOpen: false,
      baseCss: this.componentBaseCss('treeview-item', [])
    }
  },
  props: [
    'items',
    'folderOpen',
    'folderClosed',
    'fileIcon',
    'iconColor',
    'iconColorLightness',
    'showFileIcon',
    'checkboxes',
    'dense',
    'iconProvider'
  ],
  computed: {
    isFolder () {
      return this.items.children && this.items.children.length
    }
  },
  mounted () {
    if (this.items.expanded) {
      this.isOpen = true
    }
  },
  methods: {
    toggle (items) {
      if (!items.disabled) {
        if (this.isFolder) {
          this.isOpen = !this.isOpen
        }
        items.expanded = this.isOpen
        items.isFolder = !!items.children
        this.$emit('node-click', items)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/treeview/treeview-item.vue